export class EstadoPaquete {
    estadoPaqueteId: number;
    estado: number;

    copiar(objeto: any){
        this.estadoPaqueteId = objeto.estadoPaqueteId;
        this.estado = objeto.estado;
    }
}